'use client'

import { useEffect } from 'react'

import '@/app/globals.css'
import { RouteErrorFallback } from '@/components/error/route-error-fallback'

// Replaces the root layout when it (or anything above a nested error.tsx) throws, so it renders
// its own <html>/<body> without the providers: no next-intl, no theme — the copy is English and
// the page uses the default (dark) tokens.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('[GlobalError]', error)
  }, [error])

  return (
    <html lang="en" className="dark">
      <body className="font-sans antialiased">
        <RouteErrorFallback
          title="Something went wrong."
          description="The app hit an unexpected error. Your orders and positions are unaffected."
          retryLabel="Try again"
          onRetry={reset}
        />
      </body>
    </html>
  )
}
